

<template>
    <div class="recovery-container">
        <div class="red_top_bgs">
            <div class="back_lefts" @click="$router.back()" />
            <div class="big_tits" style="color: #000;">
                追回记录
            </div>
        </div>
        <div v-for="(item, index) in recoveryList" :key="index" class="recovery-item">
            <div class="headers">
                <span class="amount">追回额度: {{ item.amount }}元</span>
                <span class="amount">平台名称: {{ item.platform }}</span>
                <span class="time">{{ item.time }}</span>
            </div>

            <div class="timeline">
                <div v-for="(step, stepIndex) in steps" :key="stepIndex" class="timeline-step" :class="{
                    'active': item.currentStep >= stepIndex + 1,
                    'completed': item.currentStep > stepIndex + 1
                }">
                    <div class="step-circle">{{ stepIndex + 1 }}</div>
                    <div class="step-label">{{ step.label }}</div>
                    <div class="step-line" v-if="stepIndex < steps.length - 1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch'
export default {
    data() {
        return {
            steps: [
                { label: '提交成功' },
                { label: '审核通过' },
                // { label: '已加急受理' },
                { label: '成功追回' }
            ],
            recoveryList: [] // 从后端获取的数据
        }
    },
    created() {
        this.records_detail();
        this.$parent.footer('user', false);
    },
    methods: {
        async starts() {
            const r = await Fetch('/user/info');
            this.datawudi = r.data;
        },
        async records_detail() {
            await this.starts();
            Fetch('/index/recovery_detail', { id: this.datawudi.uid }).then((r) => {
                if (r.data) {
                    this.recoveryList = r.data.map(item => ({
                        amount: item.money,
						platform: item.platform,
                        time: item.time,
                        currentStep: item.progress_status // 0-3对应四个步骤
                    }));
                    console.log(r, "1123");


                } else {
                    console.log(r, "~~~~");
                    // this.currentStatus = 0

                }

            });
        },
    }
}
</script>

<style lang="less" scoped>
// /deep/ #app {
//   font-size: 16px;
//   background: url(../images/user/8b4.jpg) no-repeat center;
//     background-size: 112% 102%;
// }
.recovery-container {
    padding: 20px;
    height: auto;
    // background: url(../images/user/8b4.jpg) no-repeat center;
    // background-size: 112% 102%;
}

.recovery-item {
    margin-bottom: 30px;
    border: 1px solid #fff;
    background: #fff;
    border-radius: 4px;
    padding: 15px;
}

.headers {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    font-size: 16px;
    flex-direction: column;
    padding: 5px;
}

.amount {
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
}

.time {
    color: #000;
}

.timeline {
    display: flex;
    position: relative;
}

.timeline-step {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.step-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ddd;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    z-index: 1;
}

.step-line {
    position: absolute;
    top: 12px;
    left: 50%;
    width: 100%;
    height: 2px;
    background: #ddd;
    z-index: 0;
}

.timeline-step.active .step-circle {
    background: #409EFF;
}

.timeline-step.completed .step-circle {
    background: #409EFF;
}
.red_top_bgs {
    // left: 0;
    width: 100%;
    height: 44px;
    margin: 0 auto 10px;
    position: relative;
    // background-color: #e40611;
    overflow: hidden;
}
.back_lefts {
    width: 20px;
    height: 20px;
    background: url(../images/item/back.png) no-repeat center center;
    background-size: auto 100%;
    margin: 12px 0 0 8px;
}
.big_tits {
    position: absolute;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 25px;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
}
</style>
